import script from "./QRCodeScanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./QRCodeScanner.vue?vue&type=script&setup=true&lang=ts"

import "./QRCodeScanner.vue?vue&type=style&index=0&id=a88c2b3a&scoped=true&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_typescript@4.5.5__webpack@5.106.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a88c2b3a"]])

export default __exports__